import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const HarvardArtMuseums = ({featuredProjectsList}) => {
  const project = getProject('harvard-art-museums');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <Image
          component={{
            image: '//images.yourmajesty.co/20170503210048/ham1.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            Harvard Art Museums invited Your Majesty to help collaborate on a
            new way to communicate and celebrate the campus art scene.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20170503210051/ham3.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="a-digital-community">A digital community</h2>
          <p>
            <em>Index Magazine</em> was evolved from a periodic print
            publication to a dynamic and interactive home for activity and
            conversation among students, professors, curators, artists, patrons,
            and enthusiasts. While the print edition is only available three
            times a year, the digital magazine enabled the editorial team to
            publish a diverse range of new media and content anytime they
            wanted.
          </p>
        </AnimateIn>

        <Image
          className="component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170503210049/ham2.jpg'
          }}
        />

        <Image
          className="component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170503210052/ham4.jpg'
          }}
        />

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: ['Creative Strategy']
              },

              {
                title: 'Design',
                items: ['Art Direction']
              },

              {
                title: 'Technology',
                items: ['Back-end Development', 'Front-end Development']
              },

              {
                title: 'Delivery',
                items: ['Integration Support']
              }
            ]
          }}
        />

        <LinkButton
          className="g-row"
          component={{
            url: 'http://magazine.harvardartmuseums.org/',
            title: 'Visit website'
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default HarvardArtMuseums;
